import gql from 'graphql-tag';

export const ENTITY_FRAGMENT = gql`
  fragment EntityInfo on Entity {
    id
    name
    adress
    zipCode
    town
    email
    phone
    siret
    linkedWithSomething
    idCRM
  }
`;
